import { render } from "./VerticalSteps.vue?vue&type=template&id=332fad32"
import script from "./VerticalSteps.vue?vue&type=script&lang=js"
export * from "./VerticalSteps.vue?vue&type=script&lang=js"
script.render = render

export default script